module.exports = __webpack_public_path__ + "static/CircularPro-Book.164baf0c.ttf";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/CircularPro-Book.ttf
// module id = 724
// module chunks = 168707334958949